import * as React from "react";
import {
  Box,
  Grid,
  TextField,
  OutlinedTextFieldProps,
} from "@material-ui/core";
import { MUIAdornment } from "..";
import { SvgIcon } from "../../../../components";
import { tl } from "../../../../utils";
import * as styles from "./styles.scss";
import { themeVariables } from "../_Theme";

interface MUILiveInputProps extends Omit<OutlinedTextFieldProps, 'variant'> {
  onSave: (value: string) => void;
  saveOnType?: boolean;
  autoFocus?: boolean;
  value?: string;
  placeholderComponent?: React.ReactElement;
  confirmComponent?: React.ReactElement;
  embeddedConfirm?: boolean;
  active?: boolean;
}

export const MUILiveInput = React.forwardRef<HTMLElement, MUILiveInputProps>(({ onSave, placeholderComponent, confirmComponent, embeddedConfirm = true, autoFocus = true, saveOnType = true, active = false , ...props}, ref) => {
  const [isActive, setActive] = React.useState(active);
  const [savedValue, setSavedValue] = React.useState('');
  const [value, setValue] = React.useState('');

  const throttleTO = React.useRef<ReturnType<typeof setTimeout>>(null);

  React.useEffect(() => {
    if (saveOnType) {
      clearTimeout(throttleTO.current);
      throttleTO.current = setTimeout(saveValue, 500);
    }
  }, [value]);

  React.useEffect(() => {
    setSavedValue(props.value);
    setValue(props.value);
  }, []);

  const saveValue = (evt?: any) => {
    clearTimeout(throttleTO.current);
    if (savedValue !== value && saveOnType) {
      onSave(value);
      if (evt) {
        setSavedValue(value);
        setActive(false);
      }
    } else {
      setSavedValue(value);
      onSave(value);
      setActive(false);
    }
  };

  const resetValue = () => {
    clearTimeout(throttleTO.current);
    if (savedValue !== value) {
      setValue(savedValue);
      onSave(savedValue);
    }
    setActive(false);
  };

  const onKeyUp = (evt: any) => {
    if (evt.key === "Escape") {
      resetValue();
    } else if (evt.key === "Enter") {
      saveValue(evt);
    }
  };

  return (
    
    <Box
      className={`MuiLiveInput ${styles.MuiLiveInput} ${
        isActive ? styles.active : ""
      }`}
      m={placeholderComponent ? 0 : undefined}
      //@ts-ignore
      ref={ref}
      width={props.fullWidth ? '100%' : 'auto'}
    >
      {isActive ? (
        <div className={styles.inputWrap}>
          <TextField
            variant={"outlined"}
            fullWidth
            autoFocus={autoFocus}
            onBlur={saveValue}
            {...props}
            value={value}
            InputProps={{
              onKeyUp: onKeyUp,
              endAdornment: embeddedConfirm ? (
                <MUIAdornment onClick={(evt) =>saveValue(evt)}>
                  <button
                    type="reset"
                    aria-label={tl("Сохранить")}
                    onClick={saveValue}
                  >
                    {confirmComponent ? React.cloneElement(confirmComponent) : <SvgIcon type="notification success" />}
                  </button>
                </MUIAdornment>
              ) : '',
            }}
            onChange={(evt: any) => {
              setValue(evt.target.value);
            }}
          />
          {!embeddedConfirm && 
            <MUIAdornment onClick={(evt) =>saveValue(evt)}>
              <button
                className={styles.confirmBtn}
                type="reset"
                aria-label={tl("Сохранить")}
                onClick={saveValue}
              >
                {confirmComponent ? React.cloneElement(confirmComponent) : <SvgIcon type="notification success" />}
              </button>
            </MUIAdornment>
          }
        </div>
      ) : placeholderComponent 
        ? (
            <Box className={styles.notActive}>
              {
                React.cloneElement(placeholderComponent, {
                  onClick: () => {
                    setActive(true);
                  }
                })
              }
            </Box>
          )
        : (
            <Box
              bgcolor={themeVariables.palette.grey.A400}
              className={styles.notActive}
              onClick={() => {
                setActive(true);
              }}
            >
              <Grid container wrap="nowrap" alignItems="center">
                <Grid item xs className={styles.notActiveText}>
                  {props.value}
                </Grid>
                <Grid item>
                  <Box className={styles.notActiveIcon}>
                    <SvgIcon type="edit" />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}
    </Box>
  );
});
